import React from "react";

const Mail = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_16399_249081)">
      <path
        d="M3.06667 2.66663H13.7333C14.4667 2.66663 15.0667 3.26663 15.0667 3.99996V12C15.0667 12.7333 14.4667 13.3333 13.7333 13.3333H3.06667C2.33334 13.3333 1.73334 12.7333 1.73334 12V3.99996C1.73334 3.26663 2.33334 2.66663 3.06667 2.66663Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0667 4L8.4 8.66667L1.73334 4"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_16399_249081">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.400009)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default Mail;
